import {trigger, state, animate, style, transition} from '@angular/core';

export const fadeInOut =
  trigger('fadeInOut', [
    state('void', style({}) ),
    state('*', style({}) ),
    transition(':enter', [  // before 2.1: transition('void => *', [
      style({opacity: 0, position:'fixed', width:'100%'}),
      animate('0.3s ease-in-out', style({opacity: 1, position:'fixed', width:'100%'}))
    ]),
    transition(':leave', [  // before 2.1: transition('* => void', [
      style({opacity: 1, position:'fixed', width:'100%'}),
      animate('0.3s ease-in-out', style({opacity: 0, position:'fixed', width:'100%'}))
    ])
  ]);

export const fadeOut =
  trigger('fadeOut', [
    state('void', style({}) ),
    state('*', style({}) ),
    transition(':leave', [  // before 2.1: transition('* => void', [
      style({opacity: 1, position:'fixed', width:'100%'}),
      animate('0.6s ease-in-out', style({opacity: 0, position:'fixed', width:'100%'}))
    ])
  ]);

export const staticInOut =
  trigger('staticInOut', [
    state('void', style({}) ),
    state('*', style({}) ),
    transition(':enter', [  // before 2.1: transition('void => *', [
      style({zIndex: 9, background: 'white'}),
      animate('0.3s ease-in-out', style({zIndex: 9, background: 'white'}))
    ]),
    transition(':leave', [  // before 2.1: transition('* => void', [
      style({position:'fixed', width:'100%', zIndex: 0, background: 'white'}),
      animate('0.3s ease-in-out', style({position:'fixed', width:'100%', zIndex: 0, background: 'white'}))
    ])
  ]);


// WEBPACK FOOTER //
// ./src/app/router.animations.ts